import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@material-ui/core";
import { Warning } from "@material-ui/icons";
import { withRouter } from "react-router";

import { registroHistorialProps } from "src/utils/interfaces";

import { formatearIntervalo, minutosAFormatoHhmm } from "src/utils/fechas";
import { getMainScroll, setQueryParam } from "src/utils/domAndURLs";

const RegistroHistorial: React.FC<registroHistorialProps> = (
  props: registroHistorialProps
) => {
  const esOperario = props.cargo?.toLowerCase().includes("ope");
  const esNoProcesada = props.tipo === "SIN-A";
  const tipo = esNoProcesada ? "no-procesada" : "procesada";
  const tipoHora = props.cod_hora;

  console.log(props)

  const reclamar = () => {
    const alturaActual = getMainScroll() ?? 0;
    const newURL = setQueryParam("previousHeight", alturaActual);
    const urlSinHost = `${newURL.pathname}${newURL.search}`;
    props.history.push(urlSinHost);

    const linkReclamo = `/reclamos/procesar/${props.id}?tipo=${tipo}&pageFrom=${props.location.pathname}`;
    props.history.push(linkReclamo);
  };

  const entrada = !isNaN(props.horaEntrada)
    ? minutosAFormatoHhmm(props.horaEntrada)
    : "-";
  const salida = !isNaN(props.horaSalida)
    ? minutosAFormatoHhmm(props.horaSalida)
    : "-";
  const duracion = !isNaN(props.tiempoTrabajado)
    ? formatearIntervalo(props.tiempoTrabajado)
    : "-";

  const infoEnBaseATipoDeHora = esNoProcesada ? (
    <div className="row">
      <div>
        <Typography variant="body2" display="inline" color="error">
          No se encontró asignación para estas marcaciones
        </Typography>
      </div>
    </div>
  ) : (
    <div className="row">
      <div>
        <Typography variant="body2" display="inline">
          Horas trabajadas:{" "}
        </Typography>

        <Typography variant="body2" display="inline">
          {duracion}  <Typography variant="subtitle1" >Tipo de Hora: {tipoHora}</Typography> 
        </Typography>
      </div>
    </div>
  );

  const acciones = esOperario ? (
    <CardActions>
      <Button size="small" color="primary" onClick={reclamar}>
        Reclamar
      </Button>
    </CardActions>
  ) : null;

  return (
    <Card className="registro-historial mb-1">
      <CardContent>
        <div className="card-header">
          <Typography className="pr-2" variant="subtitle1">
            {props.nombrePuntoServicio}
          </Typography>
        </div>

        <div className="card-body">
          <div className="row">
            <div className="w-50">
              <Typography variant="body2" display="inline">
                Entrada:{" "}
              </Typography>

              <Typography variant="body2" display="inline">
                {entrada}
              </Typography>
            </div>

            <div className="w-50">
              <Typography variant="body2" display="inline">
                Salida:{" "}
              </Typography>

              <Typography variant="body2" display="inline">
                {salida}
              </Typography>
            </div>
          </div>

          {infoEnBaseATipoDeHora}
        </div>

        {esNoProcesada && (
          <Warning className="card-status-icon" color="secondary" />
        )}
      </CardContent>

      {acciones}
    </Card>
  );
};

export default withRouter(RegistroHistorial);
